import './tab-navigation.scss';

class TabNavigation {
    constructor ($element) {
        this.$tabNavigation = $element;
        this.$tabsContainer = this.$tabNavigation.querySelector('[data-tab-navigation="tabs"]');
        this.$$tabs = [];
        this.$$tabPanels = this.$tabNavigation.querySelectorAll('[data-tab-navigation="tab-panel"]');

        this.initialize();
    }

    initialize () {
        this.setEvents(this.$tabNavigation);

        window.addEventListener('tab_navigation.update_tabs', (e) => {
            // clear current tabs and refill with fresh tabs
            this.$tabsContainer.innerHTML = '';
            this.$tabsContainer.innerHTML = e.detail.$context.querySelector('[data-tab-navigation="tabs"]')?.innerHTML || '';

            // re init tab navigation tabs after changing tabs via fetch
            this.setEvents(this.$tabNavigation);
        });

        window.addEventListener('tab_navigation.clear_tab_panels', () => {
            // clear the content of all tab panels
            this.$$tabPanels.forEach($tabPanel => {
                $tabPanel.innerHTML = '';
            });
        });
    }

    setEvents ($root) {
        this.$$tabs = $root.querySelectorAll('[data-tab-navigation="tab"]');

        if (this.$$tabs.length > 0) {
            this.$$tabs.forEach($tab => {
                $tab.onclick = (e) => {
                    if (e.target.getAttribute('aria-selected') !== 'true') {
                        const tabPanelId = $tab.getAttribute('aria-controls');
                        const $activeTabPanel = this.$tabNavigation.querySelector(`#${tabPanelId}`);
                        const fetchUrl = $tab.dataset.tabNavigationFetchUrl || null;

                        // reset all tabs
                        this.$$tabs.forEach($tab => {
                            if ($tab !== e.target) {
                                $tab.setAttribute('aria-selected', 'false');
                            }
                        });

                        // reset all tab panels
                        this.$$tabPanels.forEach($tabPanel => {
                            if ($tabPanel.id !== tabPanelId) {
                                $tabPanel.setAttribute('data-tab-panel-active', 'false');
                            }
                        });

                        // custom event for tab change
                        window.dispatchEvent(new CustomEvent('tab_navigation.tab_change', {
                            view: window,
                            bubbles: true,
                            cancelable: false,
                            detail: {
                                $context: $tab
                            }
                        }));

                        if (fetchUrl !== null) {
                            // custom event for fetch tab content
                            window.dispatchEvent(new CustomEvent('tab_navigation.tab_fetch', {
                                view: window,
                                bubbles: true,
                                cancelable: false,
                                detail: {
                                    $context: $tab
                                }
                            }));
                        }

                        if ($activeTabPanel) {
                            $activeTabPanel.setAttribute('data-tab-panel-active', 'true');

                            setTimeout(() => {
                                $activeTabPanel.focus();
                            }, 300);
                        }

                        $tab.setAttribute('aria-selected', 'true');
                    }
                };
            });
        }
    }
}

export { TabNavigation };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$tabNavigation = $context.querySelectorAll('[data-tab-navigation="root"]');

    if ($$tabNavigation.length > 0) {
        $$tabNavigation.forEach(($tabNavigation) => {
            const tabNavigation = new TabNavigation($tabNavigation); // eslint-disable-line
        });
    }
});
